module.exports = __webpack_public_path__ + "product-compound-capsule-01.jpg?03ed3397e5316f9eb791b1c9608c48c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-01.jpg
// module id = 98
// module chunks = 0